import { Link } from '@mui/material';

import AppLink from '@/components/AppLink';
import BasetenIcon from '@/components/Icons/BasetenIcon';
import BasetenLogo from '@/components/Logo';
import useIsOrgNavBar2025Enabled from '@/hooks/useIsOrgNavBar2025Enabled';
import { links } from '@/localization';
import { WorkspaceSections } from '@/pages/Workspace/types';
import { BasetenPageEnum } from '@/routes';
import { ColorScale } from '@/theme/colors';
import { trackClick } from '@/utils/analytics/google';

import { LogoProps } from './types';

function Logo({ variant }: LogoProps) {
  const goToWorkspace = (label: string) => () => {
    trackClick('baseten logo', label);
  };

  const isOrgNavBar2025Enabled = useIsOrgNavBar2025Enabled();

  switch (variant) {
    case 'icon':
      return (
        <AppLink
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.15s ease-in-out',
            width: 32,
            height: 32,

            '&:hover': {
              color: ColorScale.green[500],
            },
          }}
          onClick={goToWorkspace('Return to workspace')}
          color="text.default"
          data-cy="go-to-home"
          page={BasetenPageEnum.Workspace}
          params={{
            section: isOrgNavBar2025Enabled ? WorkspaceSections.Overview : WorkspaceSections.Models,
          }}
        >
          <BasetenIcon sx={{ width: 'auto', height: 24 }} />
        </AppLink>
      );

    case 'logo':
      return (
        <Link href={links.basetenHome} sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
          <BasetenLogo height={24} />
        </Link>
      );

    default:
      return null;
  }
}

export default Logo;
